export default __webpack_public_path__ + "static/googleplay-cb5bb042fecded109dd9f5be60ca875a.svg";